import { Form, Formik } from 'formik';
import React from 'react';

import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import ToggleButton from 'components/v2/compiler/panels/toggleable/ToggleButton';
import { ExpandablePanel, ExpandablePanelHeaderName, HeaderCaptionSemiBold } from 'styles/v2/Styles.styled';
import { FilterChips } from './FilterChips';

interface AdminSearchFormProps {
  title: string;
  displayMap?: Record<string, (value: any) => string>;
  initialValues: any;
  validationSchema?: any;
  onSubmit: (values: any) => void;
  isLoading?: boolean;
  isSearchComplete?: boolean;
  children: React.ReactNode;
}

export const AdminSearchForm = ({
  title,
  displayMap,
  initialValues,
  validationSchema,
  onSubmit,
  isLoading = false,
  isSearchComplete = false,
  children,
}: AdminSearchFormProps) => {
  const headerTemplate = (options: any) => (
    <div
      className={`${options.className} ${options.collapsed ? 'header-collapsed' : ''}`}
      style={{ display: 'flex', alignItems: 'top' }}
    >
      <ExpandablePanelHeaderName>
        <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'start', gap: '4px' }}>
          <HeaderCaptionSemiBold>{title}</HeaderCaptionSemiBold>
          <ToggleButton options={options} />
        </div>
        {options.collapsed && <FilterChips displayMap={displayMap} isSearchComplete={isSearchComplete} />}
      </ExpandablePanelHeaderName>
    </div>
  );

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ resetForm, dirty }) => (
        <Form>
          <ExpandablePanel headerTemplate={headerTemplate} toggleable>
            <div>{children}</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1.5rem', marginTop: '41px' }}>
              <SecondaryButton
                style={{ justifyContent: 'center' }}
                disabled={!dirty}
                type="reset"
                onClick={() => resetForm()}
              >
                Clear
              </SecondaryButton>
              <PrimaryButton style={{ justifyContent: 'center', gap: 'inherit' }} type="submit" loading={isLoading}>
                Search
              </PrimaryButton>
            </div>
          </ExpandablePanel>
        </Form>
      )}
    </Formik>
  );
};
